import { useRequiredContext } from "@redotech/react-util/context";
import TagIcon from "@redotech/redo-icons/tag-01.svg";
import TagFilledIcon from "@redotech/redo-icons/tag-01_filled.svg";
import { MerchantRoutesContext } from "@redotech/redo-merchant-app-common/merchant-routes";
import { RedoSecondaryNavItem } from "@redotech/redo-web/arbiter-components/navigation/secondary/redo-secondary-nav-item";
import { memo } from "react";

export const PricingTestItems = memo(function PricingTestItems() {
  const routes = useRequiredContext(MerchantRoutesContext);

  return (
    <RedoSecondaryNavItem
      action={{
        type: "link",
        href: routes.getConversionSubRoute("pricing-tests"),
      }}
      FilledIcon={TagFilledIcon}
      friendlyName="Pricing tests"
      id="pricing-tests"
      UnfilledIcon={TagIcon}
    />
  );
});
